import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import MarketingEmailModel from "../models/MarketingEmailModel";

export interface SearchMarketingEmailParam {
    system: string,
    subject: string,
    body: string,
    pageSize: number,
    orderBy: string,
    orderDirection: string
}

export interface SaveMarketingEmailParam {
    subject: string,
    body: string,
    emailTo: string,
    system: string,
}

const axiosConfig = {
    headers: {
        ignoreCredentials: true
    }
};

const MarketingEmailApi = {
    Search(param: SearchMarketingEmailParam) {
        return Api.post<SearchMarketingEmailParam, BaseResponse<MarketingEmailModel[]>>("/api/MarketingEmail/GetAll", param);
    },
    Save(param: SaveMarketingEmailParam) {
        return Api.post<SaveMarketingEmailParam, BaseResponse<MarketingEmailModel>>("/api/MarketingEmail/Save", param);
    },
};
export default MarketingEmailApi;